<template>
    <div class="about-page">
        <div class="main">
            <div class="main-img">
                <img src="/images/aboutpic.png" alt="about-us" />
            </div>
            <div class="main-info">
                <p><span class="about">About</span></p>
                <p>
                    <span class="founded"
                        >Founded in 2021 by music lovers and event producers, Hedlyner aims to
                        provide musicians with steady sources of income, allowing them to focus
                        on what they care about most — making music.</span
                    >
                </p>
                <span class="history">
                    <p>
                        When San Francisco's cost of living forced a steady exodus of
                        musicians, Hedlyner's founding team wanted to help. We built a platform
                        and community to generate more live music opportunities for artists
                        nationwide.
                    </p>
                    <p>
                        The premise is simple. Help small businesses grow customer loyalty by
                        regularly booking local musicians. The result? More money for artists.
                        More customers for businesses. More music for fans. More bookings = A
                        win for all.
                    </p>
                </span>
            </div>
        </div>
        <div class="tools">
            <div class="spacer"></div>
            <div class="artist-venue-tools">
                <div class="artist-tools">
                    <span class="artist-look">Wanna Get Booked?</span>
                    <span class="help"
                        >Meet your one-stop shop for all things music business. Find new
                        opportunities. Communicate with venues the easy way. Get paid on time.
                        Have more stage time without the hassle.</span
                    >
                    <button class="call-to-action" @click="goToArtist()">
                        <span class="explore-btn">Explore Artist Tools</span>
                    </button>
                </div>
                <div class="venue-tools">
                    <span class="venye-look">Wanna Book an Artist?</span>
                    <span class="help">
                        Meet your favorite new booking manager. Manage all your events in one
                        place. Organize your artists. Find new ones. Get streamlined from
                        booking to payment.
                    </span>
                    <button class="call-to-action-venue" @click="goToVenues()">
                        <span class="explore-btn">Explore Venue Tools</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AboutPage',
        methods: {
            goToArtist() {
                window.location.href = '/for-artists'
            },
            goToVenues() {
                window.location.href = '/for-bookers'
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    .about-page {
        display: flex;
        flex-direction: column;
        background: #000;
    }

    .main {
        display: flex;
        flex-direction: row;
    }

    .main-info {
        margin-top: 210px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        align-self: stretch;
        gap: 25px;
        position: relative;
        right: 14px;
    }

    .about {
        color: #dedede;
        font-family: Instrument Sans;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 120%;
        letter-spacing: -0.2px;
    }

    .founded {
        color: #cdeb09;
        font-family: Instrument Sans;
        font-size: 32px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.64px;
    }

    .history {
        color: #dedede;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }

    .spacer {
        border: 1px solid #8b8b8b;
        margin: 64px 60px 0px 90px;
    }
    .tools {
        display: flex;
        flex-direction: column;
        position: relative;
    }
    .artist-venue-tools {
        display: flex;
        flex-direction: row;
        align-self: stretch;
        justify-content: space-between;
        margin: 90px 180px 180px 90px;
    }

    .artist-tools {
        display: flex;
        flex-direction: column;
        flex-basis: 45%;
        align-items: center;
        gap: 23px;
        justify-content: space-between;
    }

    .venue-tools {
        display: flex;
        flex-direction: column;
        flex-basis: 45%;
        align-items: center;
        gap: 23px;
        justify-content: space-between;
    }

    .artist-look {
        color: #cdeb09;
        text-align: center;
        font-family: Instrument Sans;
        font-size: 44px;
        font-style: normal;
        font-weight: 550;
        line-height: 110%;
        letter-spacing: -1.76px;
    }

    .help {
        color: #dedede;
        text-align: center;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }

    .call-to-action {
        display: flex;
        padding: 11px 30px 12px 30px;
        justify-content: center;
        align-items: center;
        border-radius: 100px;
        background: #cdeb09;
    }

    .explore-btn {
        color: (--black, #000);
        text-align: center;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }

    .venye-look {
        color: #ba87ff;
        text-align: center;
        font-family: Instrument Sans;
        font-size: 44px;
        font-style: normal;
        font-weight: 550;
        line-height: 110%;
        letter-spacing: -1.76px;
    }

    .call-to-action-venue {
        display: flex;
        padding: 11px 30px 12px 30px;
        justify-content: center;
        align-items: center;
        border-radius: 100px;
        background: #ba87ff;
        border: none;
    }
    @media only screen and (max-width: 1100px) {
        .about-page {
            margin-top: 50px;
        }
        .main {
            position: relative;
            height: 70vh;
        }
        .main-info {
            right: 0;
            margin-top: 0;
            padding: 0 16px;
            gap: 24px;
            top: 50px;
        }
        .artist-venue-tools {
            flex-direction: column;
            margin: 0;
            gap: 128px;
            margin-bottom: 200px;
        }
        .founded {
            color: #cdeb09;
            text-shadow: 0px 0px 50px #000;
            font-family: Instrument Sans;
            font-size: 32px;
            font-style: normal;
            font-weight: 500;
            line-height: 120%;
            letter-spacing: -0.64px;
        }
        .history {
            color: #f5f5f5;
            text-shadow: 0px 0px 50px #000;
            font-family: Instrument Sans;
            font-size: 18px;
            font-style: normal;
            font-weight: 650;
            line-height: 120%;
        }
        .main-img {
            position: absolute;
        }
        img {
            max-width: 100%;
            height: -webkit-fill-available;
        }
    }
    @media only screen and (max-width: 700px) {
        .main {
            height: 100%;
        }
        .about-page {
            margin-top: 40px;
        }
        .tools {
            top: 40px;
        }
        .spacer {
            border: 1px solid #8b8b8b;
            margin: 64px auto;
            width: 90%;
        }
    }
</style>
